
import * as React from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/system/Box';
import { usePallet } from '../contexts/PalletContext';
import styled from "styled-components";
import useStyles from '../components/layout/Styles';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';

interface IProps {
    label?: string,
    placeholder?: string,
    value?: string,
    focused?: boolean,
    className?: string,
    inputValue?: string,
    onChange?: (value: string) => void,
}

export default function SearchTextField(props: IProps) {

    const classes = useStyles();
    const { pallet } = usePallet();
    const [inputValue, setInputValue] = React.useState<string | null>(props.value || null);

    const handleChange = (value: string | null) => {
        setInputValue(value)
        props.onChange && props.onChange(value)
    };

    return (
        <Box
            component="form"
            noValidate
        >
            <div>
                <TextField
                    fullWidth
                    label={props.label ? props.label : null}
                    placeholder={props.placeholder}
                    variant='outlined'
                    value={inputValue}
                    onChange={(e) => handleChange(e.target.value)}
                    InputProps={{
                        classes: {
                            notchedOutline: classes.notchedOutline
                        },
                        style: {
                            fontFamily: `${pallet.general.fontFamily}`,
                            fontSize: `${pallet.general.size14}`,
                            fontWeight: pallet.general.weight_100,
                            background: `${pallet.backgroundColorSecondary}`
                        },
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        )
                    }}
                />
            </div>
        </Box>
    );
}